import axios from 'axios'
import {
  CompanyModel,
  ResponseCRUD,
  ResponseObjectPaginated,
  ResponseObject,
  ResponseObjectURL,
  TableResumen,
} from '../model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL

// INICIO ---- SERVICIOS CRUD
export function getCompany(dto: CompanyModel, page: number) {
  return axios.post<ResponseObjectPaginated<CompanyModel[]>>(
    `${BASEURL}/company/getAll/${page}`,
    dto,
  )
}

export function getCompanyById(dto: string | undefined) {
  return axios.get<ResponseObject<CompanyModel>>(
    `${BASEURL}/company/getInformationById?companyId=${dto}`,
  )
}

export function createCompany(dto: CompanyModel) {
  return axios.post<ResponseCRUD>(`${BASEURL}/company/createCompany`, dto)
}

export function deleteCompany(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/company/deleteCompany?id=${dto}`)
}

export function updateCompany(dto: CompanyModel) {
  return axios.put<ResponseCRUD>(`${BASEURL}/company/updateCompany`, dto)
}

// FIN ---- SERVICIOS CRUD

// INICIO ---- SERVICIOS MASIVE

export function downloadTemplateCompany() {
  return axios.post<ResponseObjectURL>(
    `${BASEURL}/company/downloadTemplateBulkLoad_file`,
    {},
    {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      responseType: 'arraybuffer',
    },
  )
}

export function uploadMasiveCompany(dto: any) {
  return axios.post<ResponseObjectPaginated<TableResumen[]>>(`${BASEURL}/company/bulkLoad`, dto)
}

// FIN ---- SERVICIOS MASIVE
